import PropTypes from 'prop-types';
import cn from 'classnames';

import { ADDRESS_FIELDS, EMAIL_ADDRESS } from 'constants/formFields';

import MartyLink from 'components/common/MartyLink';
import marketplace from 'cfg/marketplace.json';
import css from 'styles/components/productdetail/egcDetailForm.scss';

const { shortName, cart: { cartName } } = marketplace;

const CHARACTER_LIMIT = 500;

const EGCDetail = ({
  design,
  onAddToCart,
  action,
  onValidateAmount,
  onValidateEmail,
  onMessageUpdate,
  isAdding,
  isAmountValid,
  isEmailValid,
  onPriceChange,
  message = ''
}, { testId }) => {
  const { minPrice, maxPrice, asin } = design;

  return (
    <form
      action={action}
      method="POST"
      onSubmit={onAddToCart}
      className={css.form}>

      <div>
        <label htmlFor="amount">Amount</label>
        <input
          id="amount"
          name="amount"
          data-test-id={testId('amount')}
          className={cn({ [css.invalid]: !isAmountValid })}
          type="number"
          onBlur={onPriceChange}
          onKeyUp={onValidateAmount}
          required={true}
          min={minPrice}
          max={maxPrice}
          step="0.01"
          placeholder={`Between $${minPrice} - $${maxPrice}`}/>
        { isAmountValid ? '' : <p className={css.invalidMsg} data-test-id={testId('invalidAmountMsg')}>Invalid Amount</p> }
      </div>

      <div>
        <label htmlFor="recipientEmail">Recipient E-Mail</label>
        <input
          id="recipientEmail"
          name="recipientEmail"
          data-test-id={testId('email')}
          className={cn({ [css.invalid]: !isEmailValid })}
          onBlur={onValidateEmail}
          type="email"
          maxLength={EMAIL_ADDRESS.maxLength}
          required={true}/>
        { isEmailValid ? '' : <p className={css.invalidMsg} data-test-id={testId('invalidEmailMsg')}>Invalid Email</p> }
      </div>

      <div>
        <label htmlFor="recipientName">Recipient Name</label>
        <input
          id="recipientName"
          name="recipientName"
          data-test-id={testId('recipientName')}
          type="text"
          maxLength={ADDRESS_FIELDS.FULL_NAME.maxLength}
          required={true}/>
      </div>

      <div>
        <label htmlFor="senderName">Your Name</label>
        <input
          id="senderName"
          name="senderName"
          autoComplete={ADDRESS_FIELDS.FULL_NAME.autoComplete}
          data-test-id={testId('senderName')}
          type="text"
          maxLength={ADDRESS_FIELDS.FULL_NAME.maxLength}
          required={true}/>
      </div>

      <div>
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          onChange={onMessageUpdate}
          data-test-id={testId('message')}
          maxLength="500" />
        <p data-test-id={testId('charLimit')}>{CHARACTER_LIMIT - message.length} characters remaining</p>
      </div>

      <input type="hidden" name="asin" value={asin} />
      <button type="submit" data-test-id={testId('addToCart')} disabled={isAdding}>Add to {cartName}</button>

      <p className={css.note}>
          Note: Only one {shortName} e-Gift Card purchase per order.  Gift Cards are subject to <MartyLink to="/c/gift-terms-conditions">Terms and Conditions</MartyLink>.
      </p>
    </form>
  );
};

EGCDetail.contextTypes = {
  testId: PropTypes.func
};

export default EGCDetail;
